import React from "react";
import { Link } from "gatsby";
import "./previewCard.scss";

export type PreviewCardProps = {
  link: string;
  external?: boolean;
  imageUrl: string;
  leftSub?: string;
  rightSub?: string;
  title: string;
  description?: string;
  icon?: React.ReactNode;
};

const PreviewCard = (props: PreviewCardProps) => {
  const compClass = "m-previewCard";
  const {
    link,
    external,
    description,
    imageUrl,
    leftSub,
    rightSub,
    title,
    icon,
  } = props;
  return (
    <Link to={link || "#"} target={external ? "_blank" : "self"}>
      <div className={`${compClass}__card`}>
        <div className={`${compClass}__thumb`}>
          <img src={imageUrl || ""} alt={title || ""} />
        </div>
        <div className={`${compClass}__content`}>
          <div className={`${compClass}__meta`}>
            <span className={`${compClass}__metaLeft`}>
              {icon && icon} {leftSub}
            </span>
            <span className={`${compClass}__metaRight`}>{rightSub}</span>
          </div>
          <h2
            className={`${compClass}__title`}
            dangerouslySetInnerHTML={{ __html: title }}
          ></h2>
          <p className={`${compClass}__description`}>
            {description || "Ver más."}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default PreviewCard;
